import React from 'react';
import PropTypes from 'prop-types';
import StyledEducationTabletTemplate from './educationTabletTemplate.style';

function EducationTabletTemplate({ children }) {
  return <StyledEducationTabletTemplate>{children}</StyledEducationTabletTemplate>;
}

EducationTabletTemplate.propTypes = {
  children: PropTypes.node.isRequired
};

export default EducationTabletTemplate;
